import React from 'react'
import { Navigate, Route, Routes} from 'react-router-dom'
import { TariffDetail, TariffZones } from '../../../features/tariff-detail'
import { TariffsDashboard } from '../../../features/tariffs'

export const TariffsPage = () => {
  return (
    <Routes>
      <Route path="/" element={<TariffsDashboard />} />
      <Route path="/:tariffId" element={<TariffDetail />} />
      <Route path="/:tariffId/zones" element={<TariffZones />} />
      <Route path="*" element={<Navigate to="/tariffs" replace />} />
    </Routes>
  )
}
